import { randNumber } from '@ngneat/falso';

import { randomArray } from '@library/common/functions';
import { MockPath, MockPagination } from '@library/common/http/mock-path.mock';

import {
   MockAccountListItem,
   MockAdminAccount,
   MockAccountUser,
   MockAccountBookingConfirmation,
} from './admin-account.mock';

import { MockAdminSourceSystemArray } from '../admin-source-system.mock';

export const AdminAccountsRoutes: MockPath<unknown>[] = [
   { path: 'admin/account/(.+)/.+/source-system', verb: 'GET', collection: opts => MockAdminSourceSystemArray( opts.captured[0] ) },
   { path: 'admin/account/.+/source-system', verb: 'PUT', collection: _ => [ true ]},
   { path: 'admin/account/.+/booking-confirmation', verb: 'GET', collection: _ => [ new MockAccountBookingConfirmation() ]},
   { path: 'admin/account/.+/booking-confirmation', verb: 'PUT', collection: _ => [ true ]},
   { path: 'admin/account/.+/users', verb: 'GET', collection: _ => randomArray( MockAccountUser )},
   {
      path: 'admin/account/.+/list',
      verb: 'POST',
      response: opts => ({
         collection: randomArray( MockAccountListItem ),
         pagination: MockPagination( opts?.body?.pagination ),
      }),
   },
   { path: 'admin/account/.+', verb: 'GET', collection: _ => [ new MockAdminAccount() ] },
   { path: 'admin/account', verb: 'PATCH', collection: _ => [ randNumber() ]},
   { path: 'admin/account', verb: 'POST', collection: _ => [ randNumber() ]},
];
